import { ReactElement } from "react";

import { ReactComponent as AgroTwin } from "assets/icons/apps/goaigua-agrotwin.svg";
import { ReactComponent as Billing } from "assets/icons/apps/goaigua-billing.svg";
import { ReactComponent as ClogSpot } from "assets/icons/apps/goaigua-clogspot.svg";
import { ReactComponent as DMD } from "assets/icons/apps/goaigua-dmd.svg";
import { ReactComponent as EWS } from "assets/icons/apps/goaigua-ews.svg";
import { ReactComponent as FlowSense } from "assets/icons/apps/goaigua-flowsense.svg";
import { ReactComponent as MeterInsights } from "assets/icons/apps/goaigua-meterinsights.svg";
import { ReactComponent as Sentinel } from "assets/icons/apps/goaigua-sentinel.svg";
import { ReactComponent as SewerProtect } from "assets/icons/apps/goaigua-sewerprotect.svg";
import { ReactComponent as SewerTwinAce } from "assets/icons/apps/goaigua-sewertwinace.svg";
import { ReactComponent as SmartGreen } from "assets/icons/apps/goaigua-smartgreen.svg";
import { ReactComponent as WaterTwinAce } from "assets/icons/apps/goaigua-watertwinace.svg";
import { ReactComponent as WorkOrders } from "assets/icons/apps/goaigua-workorders.svg";
import { ReactComponent as WptTwin } from "assets/icons/apps/goaigua-wpttwin.svg";
import { ReactComponent as Cockpit } from "assets/icons/apps/goaigua-cockpit.svg";
import { ReactComponent as Dsf } from "assets/icons/apps/goaigua-dsf.svg";
import { ReactComponent as Hierarchy } from "assets/icons/apps/goaigua-wpttwin.svg";
import { ReactComponent as Users } from "assets/icons/apps/goaigua-usermanagement.svg";
import { ReactComponent as Gis } from "assets/icons/apps/goaigua-gis.svg";
import { ReactComponent as Biorisk } from "assets/icons/apps/goaigua-biorisk.svg";
import { ReactComponent as Customersportal } from "assets/icons/apps/goaigua-customersportal.svg";
import { ReactComponent as DeviceManagement } from "assets/icons/apps/goaigua-device-management.svg";
import { ReactComponent as Soc } from "assets/icons/apps/goaigua-soc.svg";
import { ReactComponent as Bi } from "assets/icons/apps/goaigua-bi.svg";
import { ReactComponent as Reports } from "assets/icons/apps/goaigua-reports.svg";
import { ReactComponent as IOT } from "assets/icons/apps/goaigua-iot.svg";
import { ReactComponent as PipePlanner } from "assets/icons/apps/goaigua_pipe_planner_icon.svg";

import { ReactComponent as GADrinkingWater } from "assets/Logos-Xylem-goAigua/Global-Header-Dark-DrinkingWater.svg";
import { ReactComponent as GAWastewater } from "assets/Logos-Xylem-goAigua/Global-Header-Dark-Wastewater.svg";
import { ReactComponent as GAIrrigation } from "assets/Logos-Xylem-goAigua/Global-Header-Dark-Irrigation.svg";
import { ReactComponent as GASwe } from "assets/Logos-Xylem-goAigua/Global-Header-Dark-SWE.svg";
import { ReactComponent as GAGeneral } from "assets/Logos-Xylem-goAigua/Global-Header-Dark-BiPanel.svg";
import { ReactComponent as GAWaterResources } from "assets/Logos-Xylem-goAigua/Global-Header-Dark-WaterResources.svg";
import { ReactComponent as GAAgriculture } from "assets/Logos-Xylem-goAigua/Global-Header-Dark-Agriculture.svg";

import { ReactComponent as GADrinkingWaterLight } from "assets/Logos-Xylem-goAigua/Global-Header-Light-DrinkingWater.svg";
import { ReactComponent as GAWastewaterLight } from "assets/Logos-Xylem-goAigua/Global-Header-Light-Wastewater.svg";
import { ReactComponent as GAIrrigationLight } from "assets/Logos-Xylem-goAigua/Global-Header-Light-Irrigation.svg";
import { ReactComponent as GASweLight } from "assets/Logos-Xylem-goAigua/Global-Header-Light-SWE.svg";
import { ReactComponent as GAGeneralLight } from "assets/Logos-Xylem-goAigua/Global-Header-Light-BiPanel.svg";
import { ReactComponent as GAWaterResourcesLight } from "assets/Logos-Xylem-goAigua/Global-Header-Light-WaterResources.svg";
import { ReactComponent as GAAgricultureLight } from "assets/Logos-Xylem-goAigua/Global-Header-Light-Agriculture.svg";

export type SVGMap = {
    [key: string]: () => ReactElement;
};

export const applicationLogos: SVGMap = {
    goaigua_flow_sense_icon: () => <FlowSense />,
    goaigua_meter_insights_icon: () => <MeterInsights />,
    goaigua_water_twin_icon: () => <WaterTwinAce />,
    goaigua_water_twin_ace_icon: () => <WaterTwinAce />,
    goaigua_work_orders_icon: () => <WorkOrders />,
    goaigua_billing_icon: () => <Billing />,
    goaigua_sewer_protect_icon: () => <SewerProtect />,
    goaigua_clog_spot_icon: () => <ClogSpot />,
    goaigua_sewer_twin_icon: () => <SewerTwinAce />,
    goaigua_sewer_twin_ace_icon: () => <WaterTwinAce />,
    goaigua_smart_green_icon: () => <SmartGreen />,
    goaigua_agro_twin_icon: () => <AgroTwin />,
    goaigua_ews_icon: () => <EWS />,
    goaigua_dmd_icon: () => <DMD />,
    goaigua_iot_icon: () => <WptTwin />,
    goaigua_sentinel_icon: () => <Sentinel />,
    goaigua_gis_icon: () => <Gis />,
    goaigua_hierarchy_management_icon: () => <Hierarchy />,
    goaigua_user_management_icon: () => <Users />,
    goaigua_data_science_framework_icon: () => <Dsf />,
    goaigua_cockpit_icon: () => <Cockpit />,
    goaigua_soc_icon: () => <Soc />,
    goaigua_bi_icon: () => <Bi />,
    goaigua_reports_icon: () => <Reports />,
    goaigua_device_management_icon: () => <DeviceManagement />,
    goaigua_pipe_planner_icon: () => <PipePlanner />,
};

export const logos: SVGMap = {
    goaigua_water_logo: () => <GADrinkingWater />,
    goaigua_wastewater_logo: () => <GAWastewater />,
    goaigua_irrigation_logo: () => <GAIrrigation />,
    goaigua_agriculture_logo: () => <GAAgriculture />,
    goaigua_hidrology_logo: () => <GAWaterResources />,
    goaigua_smart_water_engine_logo: () => <GASwe />,
    goaigua_logo: () => <GAGeneral />,
};

export const logosLight: SVGMap = {
    goaigua_water_logo: () => <GADrinkingWaterLight />,
    goaigua_wastewater_logo: () => <GAWastewaterLight />,
    goaigua_irrigation_logo: () => <GAIrrigationLight />,
    goaigua_agriculture_logo: () => <GAAgricultureLight />,
    goaigua_hidrology_logo: () => <GAWaterResourcesLight />,
    goaigua_smart_water_engine_logo: () => <GASweLight />,
    goaigua_logo: () => <GAGeneralLight />,
};
